async function mintPubliclist(amount) {
    event.preventDefault(); // Prevent default action if called from a form
    document.getElementById('click1').play();

    try {
        // Connect to Web3 and get the user's account
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const account = accounts[0];

        // No need to get the amount from the input field, it's passed directly as a parameter
        if (amount < 1 || amount > 4) {
            throw new Error("Invalid amount. Please enter 1 or 4.");
        }
        
        const addressToProve = account;

        // Contract interaction
        const web3 = new Web3(window.ethereum);
        const abiUrl = '/abi/abi.php';
        const response = await fetch(abiUrl);
        const contractAbi = await response.json();
        const contract = new web3.eth.Contract(contractAbi, contractAddress);
        
        // Check if EVLIST minting is enabled
        document.getElementById('typing').play();
        console.log("Checking if Gate is open...");
        const isPublicMintEnabled = await contract.methods.isPublicMintEnabled().call();
        
        console.log(`Is boarding start: ${isPublicMintEnabled}`);
        if (!isPublicMintEnabled) {
            throw new Error("Boarding is not open yet");
        }

        // Convert string values to BigNumber
        const maxPublicSupply = web3.utils.toBN(await contract.methods.MAX_PUBLIC_SUPPLY().call());
        const currentPublicSupply = web3.utils.toBN(await contract.methods.publicSupply().call());
        const userMinted = web3.utils.toBN(await contract.methods.publicMinted(account).call());
        const publicMaxMint = web3.utils.toBN(await contract.methods.PUBLIC_MAX_MINT().call());
        
        console.log("Checking maximum seats available...");
        console.log(`Current seat available: ${currentPublicSupply.toString()} / ${maxPublicSupply.toString()}`);
        
        // Check if the mint would exceed the total public supply
        if (currentPublicSupply.add(web3.utils.toBN(amount)).gt(maxPublicSupply)) {
            throw new Error("Exceeds maximum seats available");
        }
        
        console.log("Checking user boarding pass...");
        console.log(`Number of seat already minted by the user: ${userMinted.toString()} / 4`);
        
        // Calculate the total minted after this transaction
        const totalMintedAfterTx = userMinted.add(web3.utils.toBN(amount));
        
        // Check if the total minted exceeds the maximum allowed per user
        if (totalMintedAfterTx.gt(publicMaxMint)) {
            throw new Error(`Transaction invalid. You are attempting to mint ${amount} more seats, but you have already minted ${userMinted.toString()} seats. The maximum number of seats you can mint is ${publicMaxMint.toString()}.`);
        }
        
        // Additional check to ensure the user does not exceed the specific case of maximum 5 mints
        if (totalMintedAfterTx.gt(web3.utils.toBN(4))) {
            throw new Error("You cannot mint more than 4 seats in total.");
        }
        
        // If the code execution reaches this point, the minting action is valid
        console.log(`Minting ${amount} seats for the user...`);

        
        // Fetch the current gas price from Etherscan Gas Oracle API
        const gasOracleApiUrl = 'https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=3BAH17RC7NK7SRBR8KE41TUNWBIVNYK4DE';
        console.log("Fetching gas price from Etherscan Gas Oracle API...");
        const gasOracleResponse = await fetch(gasOracleApiUrl);
        
        const gasOracleData = await gasOracleResponse.json();
        console.log("Etherscan Gas Oracle API Response Data:", gasOracleData);
        
        // Extract the desired gas price (e.g., ProposeGasPrice)
        const proposedGasPriceGwei = gasOracleData.result.ProposeGasPrice;
        console.log("Proposed Gas Price (in Gwei):", proposedGasPriceGwei);
        
        // Convert gas price from Gwei to Wei
        const proposedGasPriceWei = web3.utils.toWei(proposedGasPriceGwei, 'gwei');
        console.log("Proposed Gas Price (in Wei):", proposedGasPriceWei);

        document.getElementById('typing').play();
        const mintPrice = web3.utils.toWei('0.02', 'ether') * amount;
        console.log("Ticket price: " + mintPrice + " wei");
        
        console.log("Sending mint transaction...");
        const mintTx = await contract.methods.mintPublic(amount).send({
            from: account,
            value: mintPrice,
            gasLimit: 250000,
            gasPrice: proposedGasPriceWei 
        });
        document.getElementById('typing').play();
        console.log(`Mint transaction: ${JSON.stringify(mintTx)}`);
        document.getElementById('airport-stamp').style.display = 'block';
        document.getElementById('stamp-audio').play();

        document.getElementById('success').innerHTML = "Mint successful!";
        await checkpb();
    } catch (error) {
        console.log(error);
        document.getElementById('errors').innerHTML = `<ul class="error"><li>${error.message}</li></ul>`;
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('.mint-buttons button').forEach(button => {
        button.addEventListener('click', async (e) => {
            const amount = parseInt(e.target.getAttribute('data-amount'));
            await mintPubliclist(amount);
        });
    });
    
    document.getElementById('share-button').addEventListener('click', function() {
        var textToShare = "EV3, ready for an exciting journey. Where every coral nurtured whispers the secrets of the ocean's heart, echoing a symphony of life beneath the waves. #EV3 #BlueCode";
        var urlToShare = "https://opensea.io/collection/ev3nft"; // Replace with the URL of your choice
        var twitterUrl = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(textToShare + " " + urlToShare);
    
        window.open(twitterUrl, '_blank', 'width=550,height=420'); // Open Twitter in a new window
    });
});

async function checkpb() {
    try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const addressToProve = accounts[0];
        const web3 = new Web3(window.ethereum);
        const abiUrl = '/abi/abi.php';
        const response = await fetch(abiUrl);
        const contractAbi = await response.json();
        const contract = new web3.eth.Contract(contractAbi, contractAddress);

        // Check if public minting is enabled
        const isPublicMintEnabled = await contract.methods.isPublicMintEnabled().call();
        
        // Call other necessary contract methods
        const publicMinted = await contract.methods.publicMinted(addressToProve).call();
        const nftBalance = await contract.methods.balanceOf(addressToProve).call();

        console.log(`onboarding address: ${addressToProve}`);
        console.log(`Gate Open status: ${isPublicMintEnabled}`);
        console.log(`Checkin Number: ${publicMinted}`);
        console.log(`EV Contract: ${contractAddress}`);
        console.log(`Total Seat Holding: ${nftBalance}`);
        
        const boxElement = document.getElementById('box');
        boxElement.style.display = 'block';
        boxElement.classList.add('fadeIn');
        
        const formattedAddress = updateUIWithAccountInfo(accounts[0]);
        document.getElementById('passenger-name').textContent = formattedAddress;
        document.getElementById('passenger-name-slip').textContent = formattedAddress;

        // Additional logic for public mint
        if (isPublicMintEnabled) {
            document.getElementById('paper').play();
            document.getElementById('airport').play();
            // Update with actual values if evValid is true
            document.getElementById('flight').textContent = 'EV3';
            document.getElementById('seat').textContent = 'PB-A';
            document.getElementById('flight-slip').textContent = 'EV3';
            document.getElementById('seat-slip').textContent = 'PB-A';
            document.getElementById('gate').textContent = `${nftBalance} / 5`;
            const mintButtons = document.querySelector('.mint-buttons');
            mintButtons.classList.remove('hidden');
        } else {
            document.getElementById('paper').play();
            document.getElementById('airport').play();
            // Update with actual values if evValid is true
            document.getElementById('flight').textContent = 'EV3';
            document.getElementById('seat').textContent = 'PB-A';
            document.getElementById('flight-slip').textContent = 'EV3';
            document.getElementById('seat-slip').textContent = 'PB-A';
            document.getElementById('gate').textContent = `${nftBalance} / 5`;
            const mintButtons = document.querySelector('.mint-buttons');
            mintButtons.classList.remove('hidden');
        }

        document.getElementById('typing').play();
        document.getElementById('boarding-time').innerHTML = '11:00 31TH JANUARY 2024';

    } catch (error) {
        console.log(error);
    }
}


async function connectWallet() {
    document.getElementById('click1').play();
    
  try {
    // Connect to MetaMask
    const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
    updateUIWithAccountInfo(accounts[0]);
    
    // Check current network
    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
    if (chainId !== '0x1') {
      try {
        // Request to switch to the Ethereum Mainnet
        await window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0x1' }],
        });
      } catch (switchError) {
        // Handle error, user rejected the request or the network is not added to MetaMask
        console.error('Unable to switch to the Ethereum Mainnet', switchError);
        document.getElementById('errors').innerHTML = `<ul class="error"><li>Unable to switch to Ethereum Mainnet. Please change it manually in MetaMask.</li></ul>`;
        return;
      }
    }

    // After successful connection, check whitelist status
    await checkpb();

    // Listen for account changes
    window.ethereum.on('accountsChanged', function (accounts) {
      if (accounts.length > 0) {
        updateUIWithAccountInfo(accounts[0]);
        checkpb();
      } else {
        // User has disconnected their account
        resetUI();
      }
    });

    // Listen for network changes
    window.ethereum.on('chainChanged', (chainId) => {
      // Handle the new network
      console.log(`onboarding address: ${addressToProve}`);

      // You may want to reload the page or recheck conditions here
    });

  } catch (error) {
    console.log(error);
    document.getElementById('errors').innerHTML = `<ul class="error"><li>${error.message}</li></ul>`;
  }
}

function updateUIWithAccountInfo(account) {
    console.log(`Connected to account ${account}`);

    const formattedAddress = `${account.substring(0, 6)}...${account.substring(account.length - 4)}`;
    document.getElementById('connect-button').innerText = formattedAddress;

    return formattedAddress;
}


function resetUI() {
  document.getElementById('connect-button').innerText = 'CONNECT WALLET';
}


document.addEventListener('DOMContentLoaded', (event) => {
    const connectButton = document.getElementById('connect-button');
    if (connectButton) {
        connectButton.addEventListener('click', connectWallet);
    }
});

let contract;
async function updateProgressBar() {
    try {
        const totalMint = 2500; // Total mint count
        const currentMint = await contract.methods.publicSupply().call(); // Fetch current mint count from the contract

        const progressPercentage = (currentMint / totalMint) * 100;
        document.getElementById('progress-bar').style.width = progressPercentage + '%';
        document.getElementById('mint-count').innerText = `Total Minted : ${currentMint} / ${totalMint}`; // Update mint count text
    } catch (error) {
        console.error('Error updating progress bar:', error);
    }
}


async function initContract() {
    try {
        // Contract interaction
        const web3 = new Web3(window.ethereum);
        const abiUrl = '/abi/abi.php';
        const response = await fetch(abiUrl);
        const contractAbi = await response.json();

        // Initialize the contract using the already declared variable
        contract = new web3.eth.Contract(contractAbi, contractAddress);

        updateProgressBar(); // Call this after initializing the contract
    } catch (error) {
        console.error('Error initializing contract:', error);
    }
}

initContract();


// Function to append log or error messages to the console div
function appendMessage(message, isError) {
    const consoleDiv = document.getElementById("console");
    const messageDiv = document.createElement("div");
    messageDiv.style.color = isError ? "red" : "white";
    messageDiv.textContent = message;
    consoleDiv.appendChild(messageDiv);
    consoleDiv.scrollTop = consoleDiv.scrollHeight;
}

// Override console.log and console.error to display messages in the custom console
console.log = function (message) {
    appendMessage(message, false);
};

console.error = function (message) {
    appendMessage(message, true);
};

